export const siteConfig = {
  brandName: 'Jamnagar Metals',
  domain: 'jamnagarmetals.com',
  email: 'sales@jamnagarmetals.com',
  phone: '+91 9106291093',
  whatsapp: '+91 9106291093',
  workingHours: 'Mon – Sat, 09:00 – 19:00 IST (GMT+5:30)',
  natureOfBusiness: 'Manufacturer & Exporter',
  location: 'Jamnagar, Gujarat, India',
  manufacturePlant1: 'Jamnagar, Gujarat, India',
  manufacturePlant2: 'Jamnagar, Gujarat, India',
  tagline: 'Precision Hardware, Engineered in India. Shipped Worldwide.',
  description: 'Manufacturer and global exporter of precision industrial hardware — tower bolts, cabinet handles, and architectural fittings. Serving buyers across 30+ countries.',
  moqNote: 'All enquiries are treated as bulk / container-load orders. MOQ and pricing tiers confirmed with quotation.',
  bulkOrderNote: 'Container-load and mixed-SKU consolidated shipments supported. Request a quote for pricing tiers.',

  export: {
    headline: 'Worldwide Export from the Hardware Capital of India',
    incoterms: ['EXW', 'FOB', 'CIF', 'CFR', 'DDP'] as const,
    currencies: ['USD', 'EUR', 'GBP', 'AED', 'INR'] as const,
    portOfLoading: 'Mundra / Nhava Sheva, India',
    paymentTerms: ['Advance T/T', 'L/C at sight', 'D/P', 'Open account (approved buyers)'],
    leadTime: '15–35 days from PO (SKU dependent)',
    sampling: 'Free samples up to 1 kg; shipping billed to buyer',
    iecCode: 'IEC: 0820012345',
    markets: [
      { region: 'GCC & Middle East', countries: ['UAE', 'Saudi Arabia', 'Oman', 'Qatar', 'Kuwait', 'Bahrain'] },
      { region: 'Africa', countries: ['Kenya', 'Nigeria', 'South Africa', 'Egypt', 'Tanzania', 'Ethiopia'] },
      { region: 'Southeast Asia', countries: ['Malaysia', 'Indonesia', 'Philippines', 'Vietnam', 'Thailand'] },
      { region: 'Europe', countries: ['United Kingdom', 'Germany', 'Netherlands', 'Spain', 'Italy'] },
      { region: 'Americas', countries: ['United States', 'Canada', 'Brazil', 'Mexico'] },
      { region: 'Oceania', countries: ['Australia', 'New Zealand'] },
    ],
    certifications: ['ISO 9001:2015', 'IS Compliant (BIS)', 'RoHS Ready', 'SGS Inspection Available'],
  },

  legal: {
    legalOnly: true,
    entityName: 'Jamnagar Metals',
    brandStatement: 'Jamnagar Metals is a premier manufacturer and exporter of precision hardware.',
    gst: '24AAPCP3916J1Z4',
    registeredAddress: 'Jamnagar Metals, Jamnagar, Gujarat – 361001, India',
    cin: 'U72900GJ2020PTC114820',
  },
  
  catalogue: {
    useStaticPdf: true, // true: use static PDF link, false: generate dynamically
    fullCataloguePdfUrl: '/catalogues/jamnagar-metals-catalogue-2025.pdf',
  },
}

export type SiteConfig = typeof siteConfig
